import React, { useEffect, useMemo, useState } from "react";
import { showLoading } from "react-global-loading";
import { ErrorNotify } from "../../shared/Alert";
import { getApplicationRoles } from "../../helpers/backend_helper";
import CustomDataGrid from "../../components/Common/CustomDataGrid";
import "../Standards/Standards.scss";

const formatDate = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  return Number.isNaN(date.valueOf())
    ? value
    : date.toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
      });
};

const SettingsRoles = () => {
  const [roles, setRoles] = useState([]);
  const [search, setSearch] = useState("");

  const loadData = () => {
    showLoading(true);
    getApplicationRoles()
      .then((response) => {
        setRoles(response?.data || []);
      })
      .catch((error) => {
        console.error(error);
        ErrorNotify("Error occurred while fetching roles.");
      })
      .finally(() => showLoading(false));
  };

  useEffect(() => {
    loadData();
  }, []);
  const filteredRoles = useMemo(
    () =>
      roles.filter((role) =>
        `${role.name || ""} ${role.description || ""}`
          .toLowerCase()
          .includes(search.toLowerCase())
      ),
    [roles, search]
  );
  const columns = [
    {
      id: "name",
      header: "Role",
      accessorKey: "name",
      minSize: 230,
      flex: 1.15,
      cell: ({ getValue }) => (
        <div className="standards-grid__name" style={{ fontSize: 13 }}>
          <span>{(getValue() || "R").charAt(0)}</span>
          {getValue()}
        </div>
      ),
    },
    {
      id: "description",
      header: "Description",
      accessorKey: "description",
      minSize: 380,
      flex: 2,
      cell: ({ getValue }) => (
        <span className="standards-grid__description">{getValue() || "—"}</span>
      ),
    },
    {
      id: "updatedOn",
      header: "Last Updated",
      accessorFn: (row) => formatDate(row.updatedOn),
      minSize: 155,
      flex: 0.8,
    },
  ];

  return (
    <section className="security-roles">
      
      <div className="security-roles__grid">
        <CustomDataGrid
 filterContent={<section className="standards-filter-panel" aria-label="Role filters">
        <div className="standards-filter-panel__fields">
          <label>
            <span>Search</span>
            <div className="standards-filter-panel__search">
              <i className="bx bx-search" />
              <input
                value={search}
                onChange={(event) => setSearch(event.target.value)}
                placeholder="Search roles..."
              />
            </div>
          </label>
        </div>
        <div className="standards-filter-panel__actions">
          <button type="button" onClick={() => setSearch("")}>Clear</button>
        </div>
      </section>}

          data={filteredRoles}
          columns={columns}
          onRefresh={loadData}
          fileName="roles"
          recordLabel="roles"
          showToolbar={false}
          initialPageSize={15}
          rowHeight={56}
          columnHeaderHeight={56}
          gridSx={{
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#ffffff !important",
              borderBottom: "1px solid #e7ebf2",
            },
            "& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeader--sortable":
              { backgroundColor: "#ffffff !important", color: "#52627f" },
            "& .MuiDataGrid-columnHeaderTitle": {
              color: "#52627f",
              fontSize: 12,
              fontWeight: 700,
              letterSpacing: ".2px",
            },
            "& .MuiDataGrid-columnSeparator": { color: "#e7ebf2" },
            "& .MuiDataGrid-cell": {
              fontSize: 13,
              borderBottomColor: "#edf0f5",
              color: "#273957",
            },
            "& .MuiDataGrid-row": { minHeight: "56px !important" },
            "& .MuiDataGrid-footerContainer, & .MuiDataGrid-footerContainer .MuiTypography-root":
              { fontSize: 14, borderTopColor: "#e7ebf2" },
          }}
        />
      </div>
    </section>
  );
};

export default SettingsRoles;
